(function () {
    'use strict';
    var controllerId = 'classeStudenteAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'classe', classeStudenteAdd]);

    function classeStudenteAdd($scope, datacontext, sectionMenu, $uibModalInstance, classe) {        
        $scope.classe = classe;
        $scope.item = {};
        $scope.item.included = false;
        $scope.studenti = getStudenti();
        $scope.getStudenti = getStudenti;
                
        $scope.ok = function () {        	
        		var studenteList = [];
        		$("input:checkbox[name=studenteId]:checked").each(function () {
        		    studenteList.push($(this).val());
        	    });
                var result = addItems($scope.classe.Id, studenteList);
                $uibModalInstance.close(result);            
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };       

        function addItems(classeId, studenti) {
            return datacontext.classe_studentiImportList(classeId, studenti).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;

                return data;
            });
        }

        function getStudenti() {      
            return datacontext.super_studente_getAllBySocieta($scope.classe.SocietaId, $scope.item.included).then(function (studenti) {
                return $scope.studenti = studenti;
            });
        } 
    }
})();